import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Order } from '../../../../Models/Order'
import SnackBar, { SnackTypes } from '../../../UtilityComponents/SnackBar/SnackBar';
import { ReviewAPIHandler } from '../../../../services/NetworkClient/BackendAPIs/ReviewAPIHandler';
import { TextField, Typography, Avatar } from '@mui/material';
import GGLoaderButton from '../../../CommonComponents/GGLoaderButton/GGLoaderButton';
import StarRating from '../../../CommonComponents/StarRating/StarRating';
import './OrderReviewFormCarouselItem.scss';
import GGButton from '../../../CommonComponents/GGButton/GGButton';

interface OrderReviewFormCarouselItemProps {
    order: Order
}

const OrderReviewFormCarouselItem = ({ order }: OrderReviewFormCarouselItemProps) => {
    const navigate = useNavigate();

    // Snackbar based status handling 
    // Snackbar based status handling 
    const snackBarRef = useRef<{ showSnackbar(): any }>(null)
    const [snackBarParams, setSnackBarParams] = useState({
        message: "",
        state: SnackTypes.error,
    });

    const showSnackbar = (message: string, state: SnackTypes) => {
        setSnackBarParams({ message: message, state: state });
        snackBarRef.current?.showSnackbar();
    };


    const [reviewComments, setReviewComments] = useState("");
    const [rating, setRating] = useState(0);
    const [loading, setLoading] = useState(false)

    const handleRatingReviewSubmit = async () => {
        if (rating === 0) {
            showSnackbar("Please provide a rating!", SnackTypes.error);
            return;
        }
        if (reviewComments.trim() === "") {
            showSnackbar("Please provide a review!", SnackTypes.error);
            return;
        }

        const reviewData = {
            gigId: order.metaData.gig.id,
            order: order.id,
            rating: rating,
            attachments: [],
            comment: reviewComments
        }

        setLoading(true)
        ReviewAPIHandler.shared.createReview(reviewData)
            .then(() => {
                showSnackbar("Review submitted successfully!", SnackTypes.success);
                setLoading(false)
                onSubmitCompletion()
            })
            .catch((error) => {
                setLoading(false)
                showSnackbar(
                    (error as string) || "Failed to submit review!",
                    SnackTypes.error
                );
            });
    };
    
    const onSubmitCompletion = () => {
        window.location.reload();
    }


    return (
        <div className='order-review-form-carousel-item-root'>
            <SnackBar
                ref={snackBarRef}
                severity={snackBarParams.state}
                alertDuration={5000}
                message={snackBarParams.message}
            />
            <section className="rating-and-review">
                <div className="rating-and-review-header-row">
                    <Typography variant="subtitle1" className="rating-and-review-header">Order ID: <b>{order.id}</b></Typography>
                    <Typography variant="subtitle1" className="rating-and-review-header">Completed On: <b>{order.orderCompletionTimeStamp ? new Date(order.orderCompletionTimeStamp).toLocaleDateString() : "N/A"}</b></Typography>
                </div>

                <div className='order-gig-title-image-and-freelancer-info'>
                    <Avatar src={order.metaData.gig.coverImg} alt={order.metaData.gig.title}></Avatar>
                    <div className='gig-title-freelancer-info-and-order-details'>
                        <Typography variant='subtitle1' className='gig-title'>{order.metaData.gig.title}</Typography>
                        <div className='freelancer-info-and-order-details'>
                            <div className='freelancer-info'>
                                <Avatar className='rating-and-review-freelancer-avatar' src={order?.metaData.seller.profileImage} alt={order?.metaData.seller.fullName}/>
                                <Typography variant="subtitle1" className="rating-and-review-freelancer-name">{order?.metaData.seller.fullName}</Typography>
                            </div>

                            <GGButton btnColor='#000' disableClickShrink onClick={() => navigate("/order-details/" + order.id)}>Order Details</GGButton>
                        </div>
                    </div>
                </div>

                <div className="rating-and-review-content">
                    <hr></hr>

                    <StarRating
                        className="star-rating-row"
                        value={rating}
                        onChange={setRating}
                    />

                    <TextField
                        style={{ width: "70%" }}
                        value={reviewComments}
                        onChange={(e) => setReviewComments(e.target.value)}
                        className="feedback-textarea"
                        id="outlined-multiline-static"
                        multiline
                        fullWidth
                        rows={2.5}
                        placeholder="How did you like this service...?"
                    />

                    <GGLoaderButton
                        className="submit-review-btn"
                        variant="outlined"
                        style={{ width: "fit-content", border: "none" }}
                        isLoading={loading}
                        onClick={handleRatingReviewSubmit}
                    >
                        Submit Review
                    </GGLoaderButton>
                </div>
            </section>
        </div>
    )
}

export default OrderReviewFormCarouselItem